/* eslint-disable dot-notation */
import isServer from './isServer'

const sendOptimizelyCustomEvent = (eventName, data) => {
  if (isServer) {
    return
  }
  window['optimizely'] = window['optimizely'] || []

  window['optimizely'].push({
    type: 'event',
    eventName,
    tags: data,
  })
}

export default sendOptimizelyCustomEvent
